import { ReactNode } from "react";
import { cn } from "../../../lib/utils";

/**
 * The companion's voice as a quiet card — purple-tinted, orb avatar. Text only;
 * pass onClick when the nudge has a single obvious act (e.g. open recalibrate).
 */
const ClaryNudge = ({
  children,
  onClick,
  className,
}: {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}) => {
  const Tag = onClick ? "button" : "div";
  return (
    <Tag
      onClick={onClick}
      className={cn(
        "w-full rounded-2xl border border-purple-300/30 bg-gradient-to-br from-card to-purple-500/[0.04] p-4 flex items-start gap-2.5 text-start",
        onClick && "transition-shadow hover:shadow-md cursor-pointer",
        className
      )}
    >
      <span
        aria-hidden
        className="w-6 h-6 rounded-full flex-none bg-[radial-gradient(circle_at_32%_28%,#a78bfa,#6d4be0)]"
      />
      <p className="text-[12.5px] leading-relaxed text-muted-foreground min-w-0">
        <span className="font-semibold text-purple-700">Clary</span> · {children}
      </p>
    </Tag>
  );
};

export default ClaryNudge;
